import React, { useEffect, useRef, useState } from "react";
import Header from "../../../components/global/Header";
import LeftNavbar from "../../../components/global/LeftNavbar";
import {  useTranslation } from 'react-i18next';
import { getAxiosResponse, postAxiosResponse } from "../../../services/authApiRoutes/APImethods";
import APIUrls from "../../../services/APIUrls";
import DataTable, { createTheme } from "react-data-table-component";
import Constants from "../../../Constants";
import { transformBlankToNull } from "../../../services/Util";
import Select, { NonceProvider } from "react-select";
import $ from "jquery";
import { useNavigate } from "react-router-dom";
import { Breadcrumb } from "../../../components/dashboard/Breadcrumb";
import { handleError } from "../../../services/authApiRoutes/APImethods";

export default function ProjectSettingFuzzy() {
    const scrollRef = useRef(null);
    const { t } = useTranslation();
    const [fuzzyMatch,setFuzzyMatch] = useState([])
    const translate = t;
    const navigate = useNavigate()
    const [showDropDown,setShowHide] = useState('')
    const [pending, setPending] =useState(true);
    const [selectedDepartType,setSelectedDepartType] = useState('')
    const handleBidTypeChange = (bidType,row) =>{
      setShowHide('')
      setPending(true);
      var payload = row
      setSelectedDepartType(bidType.value)
      payload['bidType'] = bidType.value
      var nulledPayload = transformBlankToNull(payload)
      postAxiosResponse(APIUrls.GET_FUZZY_MATCH_BID_PREFERENCE,nulledPayload).then((res) => {
        // if (res.data !== "") {
          getData()
          
        // }
      }).catch((err) => {
        handleError(err);
      });
    }
    const toggleDropDown = (id) =>{
      showDropDown === id ? setShowHide(''):setShowHide(id)
    }
    const handleSort = async (column, sortDirection) => {
      $(".rdt_TableCol_Sortable[data-column-id='" + column.id + "']")
        .attr({ 'aria-label': column.name, 'aria-sort': sortDirection.toUpperCase() === Constants.DESC ? Constants.DESCENDING : Constants.ASCENDING });
    };

    useEffect(()=>{
      $(".lastdisable").trigger("focus");
    }, [])
    const departType = [{label : "Simple", value:"SIMPLE"},
      {label : "Tired", value:"TIERED"}]
    const columns = [
      {
        id: "userGroup.id",
        name: "Department Name",
        // maxWidth: "350px",
        selector: (row) => row.userGroup.name,
        sortable: true,
        cell: (row) => row.userGroup.name,
      },
      {
        name: "Action",
        center: true,
        selector: (row) => row.bidType,
        cell: (row) => (
          <div className="global-dropdown-block flex-center mb-0">
          <div className="global-dropdown-select">
             <Select
                className="global-dropdown-select"
                classNamePrefix="cw"
                value={departType.filter(function (option) {
                  return option.value === row.bidType;
                })}
                aria-label="department type"
                options={departType}
                onChange={(e) => handleBidTypeChange(e,row)}
              />
              </div>
        </div>
        ),
      },
    ];
    const noDataFoundComponent = () => {
      return (
        <div className="no-data-display align-center">
          <i className="nodata-icon"></i>
          <p>{Constants.NO_DATA_FOUND}</p>
        </div>
      );
    };

    const getData = () =>{
      getAxiosResponse(APIUrls.GET_FUZZY_MATCH_BID_PREFERENCE)
      .then((res) => {
        if (res.data !== "") {
          setFuzzyMatch(res.data.data)
          setPending(false);
        }
      })
      .catch((err) => {
        handleError(err);
      });
    }
    useEffect(()=>{
      getData()
    },[])
    $(".rdt_Table").attr("aria-label","Fuzzy Matching"); 
    $(document).ready(function(){
     $(".rdt_Table .rdt_TableCol span").attr("aria-hidden","true"); 
     $(".rdt_TableCol .rdt_TableCol_Sortable[disabled]").attr("tabIndex","-1"); 
    })
    const crumbs = [
      {label:'Settings', url:'settings'},
      {label:'Fuzzy matching', url:''},
    ];
  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef}>
          <div id="content" className="dashboard-wrap">
             <Breadcrumb crumbs={ crumbs } />
             <div className="project-setting-page">
                <div className="project-heading userprofile-heading">
                    <div className="back-arrow flex-center">
                    <button aria-label="back" onClick={()=>navigate('/settings')}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none">
                        <path d="M0.46967 5.96967C0.176777 6.26256 0.176777 6.73744 0.46967 7.03033L5.24264 11.8033C5.53553 12.0962 6.01041 12.0962 6.3033 11.8033C6.59619 11.5104 6.59619 11.0355 6.3033 10.7426L2.06066 6.5L6.3033 2.25736C6.59619 1.96447 6.59619 1.48959 6.3033 1.1967C6.01041 0.903806 5.53553 0.903806 5.24264 1.1967L0.46967 5.96967ZM1 7.25H14V5.75H1V7.25Z" fill="#1D4ED8"/>
                        </svg>
                    </button>
                    <span>Back to Settings</span>
                    </div>
                    <h3 className="flex">Fuzzy Matching in Vendor Quotes</h3>
                    <span>Preferences for how vendors should submit pricing quotes for fuzzy matching. </span>
                </div>
                <div className="white-bg"> 
                    <div className="gb-setting-head">
                        <h6>Fuzzy Matching Levels</h6>
                        <p>During bidding, you can customize how vendors should provide price quotes for translation memory leveraging fuzzy matching. Fuzzy matching thresholds are used to determine how closely a previously translated text matches a requested source. The two options are:</p>
                        <p><strong>Simple:</strong> Price quotes contain a single fuzzy matching category.</p>
                        <p><strong>Tiered:</strong> Price quotes contain three fuzzy matching thresholds: 75<span className="font-zero">to</span><span aria-hidden="true">-</span>84%,
                         85<span className="font-zero">to</span><span aria-hidden="true">-</span>94%,
                          95<span className="font-zero">to</span><span aria-hidden="true">-</span>99%.</p>
                    </div>
                  
                   <div className="datatable-block">
                    <DataTable
                      keyField="userGroup.id"
                      columns={columns}
                      data={fuzzyMatch}
                      //defaultSortFieldId={1}
                      //defaultSortFieldId="userGroup.id"
                      onSort={handleSort}
                      responsive
                      striped
                      pointerOnHover={true}
                      progressPending={pending}
                      noDataComponent={noDataFoundComponent()}
                    />
                  </div>
                    
                </div>
             </div>
          </div>
        </section>
      </div>


    
         
 
         
    </div>
  );
}
